<template>
  <Prompts mode="topic_pool" />
</template>

<script>
import Prompts from './Prompts.vue'

export default {
  name: 'TopicPoolSettings',
  components: { Prompts },
}
</script>
